import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {HttpClientModule} from "@angular/common/http";
import {FormsModule} from "@angular/forms";

import {AppRootComponent} from "./AppRootComponent";
import {OrganizationNotFoundPage} from "./pages/OrganizationNotFoundPage";
import {LicenseAlreadyOrderedPage} from "./pages/LicenseAlreadyOrderedPage";
import {StartPage} from "./pages/StartPage";
import {ContactAddressPage} from "./pages/ContactAddressPage";
import {BillingAddressPage} from "./pages/BillingAddressPage";
import {LicensePage} from "./pages/LicensePage";
import {AgbPage} from "./pages/AgbPage";
import {ReviewPage} from "./pages/ReviewPage";
import {SuccessPage} from "./pages/SuccessPage";
import {UserErrorPage} from "./pages/UserErrorPage";
import {ServerErrorPage} from "./pages/ServerErrorPage";

@NgModule({
  declarations: [
    AppRootComponent,
    OrganizationNotFoundPage,
    LicenseAlreadyOrderedPage,
    StartPage,
    ContactAddressPage,
    BillingAddressPage,
    LicensePage,
    AgbPage,
    ReviewPage,
    SuccessPage,
    UserErrorPage,
    ServerErrorPage,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
  ],
  bootstrap: [AppRootComponent]
})
export class AppModule {}
